import { useState } from "react";
import OutsideClickHandler from "utils/OutsideClickHandler";

function Popper({ arrow, noClick, title, children, noHover, left, leftHeader }: any) {
  const [showPopper, setShowPopper] = useState(false);

  return (
    <div className="relative">
      <div
        className={`relative flex cursor-pointer items-center justify-between ${
          noHover
            ? ""
            : showPopper
            ? "before:absolute before:bottom-[-8px] before:h-4 before:w-[50%] before:rounded-8 before:bg-primary-main before:duration-500 before:ease-in-out before:content-['']"
            : "before:absolute before:bottom-[-8px] before:h-4 before:w-0 before:rounded-8 before:bg-primary-main before:duration-500 before:ease-in-out hover:before:w-[50%] hover:before:content-['']"
        }`}
        onClick={() => setShowPopper(true)}
      >
        {title}
        {arrow && <i className={`icon-direction-1 text-16 text-gray-7C7C7C ltr:rotate-180`} />}
      </div>
      {showPopper && (
        <OutsideClickHandler handleClick={() => setShowPopper(false)}>
          <div
            onClick={() => {
              if (noClick) {
              } else setShowPopper(false);
            }}
            className={`absolute    ${
              leftHeader
                ? `top-0 ltr:left-[11.2rem]  rtl:right-[11.2rem]`
                : left
                ? `top-0 ltr:left-[16.2rem]  rtl:right-[16.2rem]`
                : "top-[160%] left-0"
            } z-[30] w-max min-w-[183px] rounded-6 bg-white p-16  shadow-[0_4px_10px_rgba(0,0,0,0.16)] `}
          >
            {children}
          </div>
        </OutsideClickHandler>
      )}
    </div>
  );
}

export default Popper;
